export default function SET_ALL_USERS(state, userData) {
    state.adminDashboard.state.allUsers = userData;
}